import { render, staticRenderFns } from "./ToggleSidebar.vue?vue&type=template&id=3510d8ce&scoped=true"
import script from "./ToggleSidebar.vue?vue&type=script&lang=js"
export * from "./ToggleSidebar.vue?vue&type=script&lang=js"
import style0 from "./ToggleSidebar.vue?vue&type=style&index=0&id=3510d8ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3510d8ce",
  null
  
)

export default component.exports